import { ILayerProviderSettings, MapProvider } from './map-provider-settings';

export class GeoserverLayerProviderSettings implements ILayerProviderSettings {
  provider = MapProvider.Geoserver;
  typeNS: string;
  typename: string;
  url: string;

  constructor(init: {
    typeNS: string;
    typename: string;
    url: string;
  }) {
    Object.assign(this, init);
  }
}
